<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="rint" title="Introduction">
<p class="fmtitlec"><b><span class="right_1" epub:type="pagebreak" id="page_7" title="7"><a href="#/text/Contents#int">Introduction</a></span></b></p>
<p class="normal">I would love to tell you that I grew up watching my grandmother cook on a cast iron skillet while I played on the kitchen floor, unwittingly picking up the secrets to perfect cast iron cooking. I wish I could tell you that she passed along her well-seasoned cast iron skillet to me when I got married.</p>
<p class="normal-ts">But it was the 1980s, full of low-fat foods, nonstick cookware, and aerobics videos. I may or may not have embraced all of those!</p>
<p class="normal-ts">I didn’t learn the secrets of cast iron cooking until I was an adult and had been cooking for several years. I wanted the ease of nonstick cookware (without the toxic effects of the coating) coupled with the superior browning produced by my expensive stainless steel pans. I also wanted cookware that I could easily transfer from stove top to oven and back.</p>
<p class="normal-ts">The cast iron skillet offered all of the features I wanted. It quickly became my go-to pan for perfectly seared meats, flavorful casseroles, and rustic stews. It also simplified Paleo cooking, which can easily become more elaborate than a menu built on meat and vegetables ever should be. One pan brought me back to the elemental principles of the Paleo movement and served up some delicious meals in the process.</p>
<p class="normal-ts">Someday when I have grandchildren, I intend to pass my culinary wisdom and recipes along to them, but they’ll have to pry the skillet out of my hands.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?098ae85c